<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col
          v-for="(file, index) in files"
          :key="index"
          cols="12"
          xs="12"
          sm="12"
          md="4"
          lg="4"
          xl="3"
      >
        <v-card>
          <v-card-title>
            {{ file.name }}
          </v-card-title>
          <v-card-subtitle
              style="height: 50px"
          >
            {{file.description }}
          </v-card-subtitle>
          <v-card-actions>
            <v-btn
                class="primary--text"
                outlined
                rounded
                text
                :href="'formulare/' + file.filename"
                target="_blank"
            >
              Download
            </v-btn>
          </v-card-actions>
          <v-spacer></v-spacer>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "FormulareUDownloads",
  data: () => ({
    files: [
      {"name": "Eintrittsformular", "filename": "Eintrittserklaerung.pdf", "description": "Einfach ausfüllen und zum nächsten Training mitbringen."},
      {"name": "Vereinssatzung", "filename": "Satzung.pdf", "description": "Satzung des SC Budokwai Garbsen e.V"},
      {"name": "Anforderungen für Kyu-Grade", "filename": "Anforderungen für Kyu-Grade.pdf", "description": "Zur Vorbereitung auf deinen nächsten Gürtel findest du hier die Prüfungsordnung."},
    ]
  }),
}
</script>

<style scoped>

</style>